// extracted by mini-css-extract-plugin
module.exports = {"Actions":"validation_Actions__2IzOt","BackButton":"validation_BackButton__2nnYU","Button":"validation_Button__37pR6","PageContent":"validation_PageContent__2Bbps"};